module.exports = __webpack_public_path__ + "11c8d45dd9208db2ebd1fbe88271dc69.png";